<template>
  <div class="login-container">
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title">管理员登录</h3>
      <el-form-item prop="userName">
        <el-input type="text" v-model="ruleForm2.userName" auto-complete="off" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="ruleForm2.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="handleSubmit" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { login } from "@/axios/api";
import { convertCase } from '@/axios/util'
import QS from "qs";
export default {
  data() {
    return {
      logining: false,
      ruleForm2: {
        userName: "",
        password: ""
      },
      rules2: {
        userName: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      checked: false
    };
  },
  methods: {
    handleSubmit(event) {
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          login(this.ruleForm2).then(res => {
            if (res.status === 200) {
              localStorage.setItem("admin", convertCase(btoa(QS.stringify(res.data))).split('').reverse().join(''));
              if (this.checked) {
                localStorage.setItem("account", this.ruleForm2.userName);
              }
              this.$router.push({ path: "/Main" });
            }
          });
        }
      });
    }
  },
  mounted() {
    let account = localStorage.getItem("account");
    if (account !== undefined && account !== null) {
      this.checked = true;
      console.log(account);
      this.ruleForm2.userName = account;
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.login-container {
  width: 100%;
  box-sizing: border-box;
  float: left;
}
.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin: 200px auto;
  width: 350px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/views/login/Login.vue